'use client';

import React from "react";
import { useTeam } from "../internals";

// Lifted verbatim from Kreta RT1 §1.3 — role chip styles.
const STYLES = {
  owner: "bg-gray-100 text-gray-800",
  admin: "bg-red-100 text-red-800",
  manager: "bg-rose-100 text-rose-800",
  staff: "bg-green-100 text-green-800",
  field_worker: "bg-orange-100 text-orange-800",
};

const LABEL_KEY = {
  owner: "role_owner",
  admin: "role_admin",
  manager: "role_manager",
  staff: "role_staff",
  field_worker: "role_field_worker",
};

export const RoleChip = ({ role }) => {
  const { copy } = useTeam();
  const cls = STYLES[role] || "bg-zinc-100 text-zinc-700";
  const label = copy[LABEL_KEY[role]] || role;
  return (
    <span
      data-testid={`role-chip-${role}`}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${cls}`}
    >
      {label}
    </span>
  );
};
